module.exports = __webpack_public_path__ + "static/media/inhouse.0f52f4c1.svg";